module.exports = __webpack_public_path__ + "static/media/Nsdl.4af1bde5.svg";